import script from "./EditUserPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditUserPage.vue?vue&type=script&setup=true&lang=js"

import "./EditUserPage.vue?vue&type=style&index=0&id=2692e9ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2692e9ca"]])

export default __exports__